export const purchaseOrdersColumns = [
  // {
  //   name: 'number',
  //   isDefault: true,
  //   property: 'number',
  //   propType: 'string',
  //   size: 1,
  //   sortable: false,
  //   sortBy: '',
  //   btnStyle: '',
  //   icon: '',
  //   action: '',
  //   route: '',
  //   align: 'left',
  //   cssClass: '',
  // },
  {
    name: 'purchaseOrder.externalReference',
    isDefault: true,
    property: 'externalReference',
    propType: 'purchaseOrder-externalReference',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: '',
  },
  {
    name: 'purchaseOrders.dateCreated',
    isDefault: true,
    property: 'created',
    propType: 'datetime',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: '',
  },
  {
    name: 'purchaseOrders.depot',
    isDefault: true,
    property: 'depot',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'purchaseOrders.supplier',
    isDefault: true,
    property: 'supplier',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left max-width-15',
  },
  {
    name: 'purchaseOrders.createdBy',
    isDefault: true,
    property: 'createdBy.name',
    propType: 'createdByName',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'purchaseOrders.estimatedPrice',
    isDefault: true,
    property: 'purchasePriceAll',
    propType: 'price-with-and-without-vat',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'purchaseOrders.status',
    isDefault: true,
    property: 'status.name',
    propType: 'purchaseOrder-status',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'stockUp',
    isDefault: true,
    property: '',
    propType: 'btn-stockup',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'layer-plus',
    action: 'stockUpOrder',
    route: '',
    align: '',
    cssClass: 'fixed-column-width pr-1 hide-th',
  },
  {
    name: 'purchaseOrders.open',
    isDefault: true,
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'first',
    icon: 'chevron-right',
    action: 'openDetail',
    route: '',
    // route: '/purchase-order/',
    align: '',
    cssClass: 'fixed-column-width pr-1',
  },
]

export const purchaseOrderItemsColumns = [
  {
    name: '',
    isDefault: true,
    property: 'image',
    propType: 'img',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: '',
  },
  {
    name: 'productName',
    isDefault: true,
    property: 'product',
    propType: 'relation-name',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: 'left text-nowrap name-column',
  },
  {
    name: 'orderNumber',
    isDefault: true,
    property: 'purchaseOrder.number',
    propType: 'purchaseOrder-link',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'Datum vytvoření',
    isDefault: true,
    property: 'purchaseOrder.created',
    propType: 'custom-relation',
    pipe: 'fmtDate',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'depot',
    isDefault: true,
    property: 'purchaseOrder.depot.name',
    propType: 'custom-relation',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'supplier',
    isDefault: true,
    property: 'purchaseOrder.supplier.name',
    propType: 'custom-relation',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'pricePerPiece',
    isDefault: true,
    property: 'purchasePrice',
    propType: 'price-with-and-without-vat',
    // customValue: 'product',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left max-width-15',
  },
  {
    name: 'quantity',
    isDefault: true,
    property: 'quantity',
    propType: 'purchaseOrderItem-quantity',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'left text-nowrap',
  },
  {
    name: 'Cena',
    isDefault: true,
    property: 'purchasePriceAll',
    propType: 'price-with-and-without-vat',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'right',
    cssClass: 'text-nowrap',
  },
  {
    name: 'cancel',
    isDefault: true,
    property: '',
    propType: 'btn',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'ban',
    action: 'stockUpCancel',
    route: '',
    align: '',
    cssClass: 'fixed-column-width pr-1',
  },
  {
    name: 'products.stockUp',
    isDefault: true,
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'first',
    icon: 'layer-plus',
    action: 'stockUp',
    route: '',
    align: '',
    cssClass: 'fixed-column-width pr-1',
  },
]

export const productMovePacksPurchaseOrderColumns = [
  {
    name: 'reports.dateCreated',
    property: 'dateCreated',
    propType: 'datetime',
    size: 1,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 product-move-pack-date',
  },
  {
    name: 'type',
    property: 'type',
    propType: 'operation-type',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'center',
  },
  {
    name: 'number',
    property: 'number',
    propType: 'integer',
    size: 1,
    sortable: true,
    sortBy: 'number',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
  },
  // {
  //   name: 'externalReference',
  //   property: '',
  //   propType: 'string',
  //   size: 1,
  //   sortable: false,
  //   sortBy: '',
  //   btnStyle: '',
  //   icon: '',
  //   action: '',
  //   route: '',
  //   align: '',
  //   cssClass: 'text-nowrap',
  // },
  {
    name: 'depot.to',
    property: '',
    propType: 'depot-to',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  // {
  //   name: 'notes',
  //   cssClass: 'max-width-30',
  //   property: 'notes',
  //   propType: 'notes',
  //   size: 2,
  //   sortable: false,
  //   sortBy: '',
  //   btnStyle: '',
  //   icon: '',
  //   action: '',
  //   route: '',
  //   align: 'left',
  // },
  {
    name: 'createdBy',
    property: 'createdBy',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'first',
    icon: 'chevron-right',
    action: '',
    route: '/product-move-pack/',
    target: '_blank',
    align: '',
    cssClass: 'pr-1',
  },
]

export const productMovePacksColumns = [
  {
    name: 'reports.dateCreated',
    property: 'dateCreated',
    propType: 'datetime',
    size: 1,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'type',
    property: 'type',
    propType: 'operation-type',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'center',
  },
  {
    name: 'number',
    property: 'number',
    propType: 'integer',
    size: 1,
    sortable: true,
    sortBy: 'number',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
  },
  {
    name: 'checkout',
    property: '',
    propType: 'checkout-name',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'depot.from.to',
    property: '',
    propType: 'depot-from-to',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'createdBy',
    property: 'createdBy',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'bill.amount',
    property: 'bill.amount',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'detail',
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/product-move-pack/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const customersColumns = [
  {
    name: 'title',
    property: 'name',
    propType: 'string',
    size: 3,
    sortable: true,
    sortBy: 'lastName',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'email',
    property: 'email',
    propType: 'string',
    size: 3,
    sortable: true,
    sortBy: 'email',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'phone',
    property: 'phone',
    propType: 'string',
    size: 3,
    sortable: true,
    sortBy: 'phone',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'tags',
    property: 'tags',
    propType: 'tags',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: 'text-nowrap',
  },
  {
    name: 'salesmen',
    property: 'users',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: 'text-nowrap',
  },
  {
    name: 'priceLevel.title',
    property: 'priceLevel',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/customer/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const vouchersColumns = [
  {
    name: 'name',
    property: 'name',
    propType: 'string',
    size: 1,
    sortable: true,
    sortBy: 'name',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'code',
    property: 'code',
    propType: 'string',
    size: 1,
    sortable: true,
    sortBy: 'code',
    cssClass: 'text-nowrap',
  },
  {
    name: 'voucher.discountValue',
    property: '',
    propType: 'types-with-values',
    size: 1,
    sortable: true,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'voucher.used.maxUse',
    property: '',
    propType: 'used-maxUse',
    size: 1,
    sortable: true,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap text-right',
  },
  {
    name: 'voucher.validFrom',
    property: 'validFrom',
    propType: 'datetime',
    size: 1,
    sortable: true,
    sortBy: 'validFrom',
    cssClass: 'text-nowrap',
  },
  {
    name: 'voucher.validTo',
    property: 'validTo',
    propType: 'datetime',
    size: 1,
    sortable: true,
    sortBy: 'validTo',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/voucher',
    align: '',
    cssClass: 'pr-1',
  },
]

export const soldItemsColumns = [
  {
    name: '',
    property: 'product',
    propType: 'img',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'title',
    property: 'name',
    propType: 'product-link',
    size: 1,
    sortable: false,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '/product/',
    align: '',
    cssClass: '',
  },
  {
    name: 'ean',
    property: 'ean',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: 'code',
    cssClass: 'text-nowrap',
  },
  {
    name: 'code',
    property: 'code',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: 'code',
    cssClass: 'text-nowrap',
  },
  {
    name: 'quantity',
    property: 'quantity',
    propType: 'integer',
    size: 1,
    sortable: false,
    sortBy: '',
    cssClass: 'text-right',
  },
  {
    name: 'priceLevel.withoutVat',
    property: 'priceAllWithoutVat',
    propType: 'price',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'right',
    cssClass: 'text-nowrap',
  },
  {
    name: 'profit',
    property: 'profit',
    propType: 'price',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'right',
    cssClass: 'text-nowrap',
  },
]

export const printPurchaseExportsColumns = [
  {
    name: 'reports.dateCreated',
    property: 'created',
    propType: 'datetime',
    size: 2,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'date.from',
    property: 'dateFrom',
    propType: 'date',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'date.to',
    property: 'dateTo',
    propType: 'date',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.depots',
    property: 'depots',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.checkouts',
    property: 'checkouts',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.suppliers',
    property: 'suppliers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'brands',
    property: 'producers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'download',
    property: '',
    propType: 'btn-gen',
    size: 1,
    sortable: false,
    sortBy: null,
    btnStyle: 'second',
    icon: '',
    action: 'downloadReport',
    route: '',
    align: '',
    cssClass: 'pr-1',
  },
]

export const printSaleExportsColumns = [
  {
    name: 'reports.dateCreated',
    property: 'created',
    propType: 'datetime',
    size: 3,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'date.from',
    property: 'dateFrom',
    propType: 'date',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'date.to',
    property: 'dateTo',
    propType: 'date',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.checkouts',
    property: 'checkouts',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.suppliers',
    property: 'suppliers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'brands',
    property: 'producers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'download',
    property: '',
    propType: 'btn-gen',
    size: 1,
    sortable: false,
    sortBy: null,
    btnStyle: 'second',
    icon: '',
    action: 'downloadReport',
    route: '',
    align: '',
    cssClass: 'pr-1',
  },
]

export const printStockExportsColumns = [
  {
    name: 'reports.dateCreated',
    property: 'created',
    propType: 'datetime',
    size: 3,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'reports.date.state',
    property: 'date',
    propType: 'date',
    size: 2,
    sortable: true,
    sortBy: 'date',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'tex-nowrap',
  },
  {
    name: 'reports.depots',
    property: 'depots',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'tex-nowrap',
  },
  {
    name: 'reports.suppliers',
    property: 'suppliers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'tex-nowrap',
  },
  {
    name: 'brands',
    property: 'producers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'tex-nowrap',
  },
  {
    name: 'download',
    property: '',
    propType: 'btn-gen',
    size: 1,
    sortable: false,
    sortBy: null,
    btnStyle: 'second',
    icon: '',
    action: 'downloadReport',
    route: '',
    align: '',
    cssClass: 'tex-nowrap pr-1',
  },
]

export const printInventoryExportsColumns = [
  {
    name: 'reports.dateCreated',
    property: 'created',
    propType: 'datetime',
    size: 3,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'reports.date.state',
    property: 'date',
    propType: 'date',
    size: 2,
    sortable: true,
    sortBy: 'date',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.depots',
    property: 'depots',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'reports.suppliers',
    property: 'suppliers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'brands',
    property: 'producers',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'inventory.approved',
    property: '',
    propType: 'approved',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: null,
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/inventory-detail',
    align: '',
    cssClass: 'pr-1',
  },
]

export const usersColumns = [
  {
    name: 'name',
    property: '',
    propType: 'fullName',
    size: 4,
    sortable: true,
    sortBy: 'lastName',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'email',
    property: 'email',
    propType: 'string',
    size: 8,
    sortable: true,
    sortBy: 'email',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 4,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/user',
    align: '',
    cssClass: 'pr-1',
  },
]

export const tagsColumns = [
  {
    name: 'name',
    property: 'name',
    propType: 'string',
    size: 3,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'type',
    property: 'type',
    propType: 'string',
    size: 3,
    sortable: true,
    sortBy: 'type',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'color',
    property: 'color',
    propType: 'string',
    size: 3,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/tag/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const depotsColumns = [
  {
    name: 'depots.name',
    property: 'name',
    propType: 'string',
    size: 10,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/depot/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const suppliersColumns = [
  {
    name: 'suppliers.name',
    property: 'name',
    propType: 'string',
    size: 10,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/supplier/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const producersColumns = [
  {
    name: 'producers.name',
    property: 'name',
    propType: 'string',
    size: 10,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/producer/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const companyCarriersColumns = [
  {
    name: 'name',
    property: 'carrier',
    propType: 'string',
    size: 6,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'checkout',
    property: 'checkout',
    propType: 'checkout-name',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'center',
    cssClass: 'text-nowrap',
  },
  {
    name: 'enable',
    property: 'enable',
    propType: 'boolean',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'center',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/company-carrier/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const parametersColumns = [
  {
    name: 'name',
    property: 'name',
    propType: 'string',
    size: 4,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'type',
    property: 'type',
    propType: 'string',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/parameter/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const paymentsColumns = [
  {
    name: 'payment.name',
    property: 'name',
    propType: 'string',
    size: 4,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'payment.type',
    property: 'type',
    propType: 'string',
    size: 4,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'payment.eetEnabled',
    property: 'eetEnable',
    propType: 'boolean',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/payment/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const vatsColumns = [
  {
    name: 'vats.name',
    property: 'name',
    propType: 'string',
    size: 9,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'vats.percent',
    property: 'percent',
    propType: 'number',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'ban',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'vats.isDefault',
    property: 'default',
    propType: 'boolean',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/vat/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const consentsColumns = [
  {
    name: 'name',
    property: 'name',
    propType: 'string',
    size: 4,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'externalId',
    property: 'externalId',
    propType: 'string',
    size: 2,
    sortable: true,
    sortBy: 'externalId',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'created',
    property: 'created',
    propType: 'datetime',
    size: 2,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'updated',
    property: 'updated',
    propType: 'datetime',
    size: 2,
    sortable: true,
    sortBy: 'updated',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/consent/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const eetCertsColumns = [
  {
    name: 'cert.name',
    property: 'name',
    propType: 'string',
    size: 4,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'cert.expirationDate',
    property: 'expirationDate',
    propType: 'datetime',
    size: 4,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/cert/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const eetShopsColumns = [
  {
    name: 'shop.name',
    property: 'name',
    propType: 'string',
    size: 4,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'shop.eetId',
    property: 'eetId',
    propType: 'integer',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'shop.cert',
    property: 'cert',
    propType: 'link',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'shop.checkouts',
    property: 'checkouts',
    propType: 'array',
    size: 4,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/shop/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const eetReceiptsColumns = [
  {
    name: 'receipt.dateCreated',
    property: 'dateCreated',
    propType: 'datetime',
    size: 6,
    sortable: true,
    sortBy: 'dateCreated',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'receipt.number',
    property: 'number',
    propType: 'integer',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'center',
  },
  {
    name: 'price',
    property: 'totalPrice',
    propType: 'price-cents',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'right',
  },
  {
    name: '',
    property: '',
    propType: 'btn-resend-eet-receipt',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: '',
    property: '',
    propType: 'modal-eet-receipt',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'fixed-column-width pr-1',
  },
]

export const institutionsColumns = [
  {
    name: 'institution.name',
    property: 'name',
    propType: 'string',
    size: 10,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'company',
    property: '',
    propType: 'string',
    size: 1,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'text-nowrap',
  },
  {
    name: 'companies',
    property: 'companies',
    propType: 'array',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: 'left',
    cssClass: 'text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/institution/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const checkoutsColumns = [
  {
    name: 'checkouts.name',
    property: 'name',
    propType: 'string',
    size: 10,
    sortable: true,
    sortBy: 'name',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1 text-nowrap',
  },
  {
    name: 'open',
    property: '',
    propType: 'btn-right',
    size: 2,
    sortable: false,
    sortBy: '',
    btnStyle: 'second',
    icon: 'chevron-right',
    action: '',
    route: '/surgery/',
    align: '',
    cssClass: 'pr-1',
  },
]

export const exportsColumns = [
  {
    name: 'reports.dateCreated',
    property: 'created',
    propType: 'datetime',
    size: 2,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'type',
    property: 'type',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    shouldBeTranslated: true,
  },
  {
    name: 'createdBy',
    property: 'createdBy',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'note',
    property: 'note',
    propType: 'string',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'download',
    property: '',
    propType: 'btn-gen',
    size: 1,
    sortable: false,
    sortBy: null,
    btnStyle: 'second',
    icon: '',
    action: 'downloadReport',
    route: '',
    align: '',
    cssClass: 'pr-1',
  },
]

export const exportOrdersColumns = [
  {
    name: 'reports.dateCreated',
    property: 'created',
    propType: 'datetime',
    size: 2,
    sortable: true,
    sortBy: 'created',
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
    cssClass: 'pl-1',
  },
  {
    name: 'type',
    property: 'type',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'depot',
    property: 'depot',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'supplier',
    property: 'supplier',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'createdBy',
    property: 'createdBy',
    propType: 'relation-name',
    size: 2,
    sortable: false,
    sortBy: null,
    btnStyle: '',
    icon: '',
    action: '',
    route: '',
    align: '',
  },
  {
    name: 'download',
    property: '',
    propType: 'btn-gen',
    size: 1,
    sortable: false,
    sortBy: null,
    btnStyle: 'second',
    icon: '',
    action: 'downloadReport',
    route: '',
    align: '',
    cssClass: 'pr-1',
  },
]
